export default __webpack_public_path__ + "AbbisWayLogo.2b3e08c559f81c3368bd7bdb047c4951.png";